import type { IPopup } from "@mm-frontend/mm-web-ui-kit";

export class CatalogManager {
  #popup: IPopup | null = null

  setPopup(popup: IPopup) {
    this.#popup = popup;
  }

  openModal() {
    this.#popup?.show();
  }

  closeModal() {
    this.#popup?.close();
  }

  get isModalOpened() {
    return this.#popup?.isShown
  }
}